// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2l6Js","select":"Header_select__35zFK","clinic":"Header_clinic__4rfoM"};